<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">TBM Point</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> / <b>Loyalty Point System</b> / <b>Loyalty Card</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div v-for="(card, index) in cards" :key="index" class="col-md-6 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              <b>{{ card.name }}</b>
            </h4>

            <div v-if="card.image" class="mb-4">
              <img :src="getImage(card.image)" width="200px" class="border">
            </div>

            <!-- <div v-else class="mb-4">
              <img src="@/assets/images/no-image-uploaded.png" width="200px" class="border">
            </div> -->

            <div class="form-group">
              <span>
                Upload Image (Please ensure the image dimension is 2338px x 1200px)
              </span>

              <input class="form-control" type="file" :ref="`${card.slug}_file`" v-on:change="handleFileUpload(card.slug)">
            </div>

            <div class="form-group mt-4">
              <label>
                Set Points Range
              </label>

              <div class="row">
                <div class="col-md-4">
                  <input class="form-control" type="number" v-model="card.min">
                </div>
                
                <div class="col-md-1 text-center">
                  To
                </div>

                <div class="col-md-4">
                  <input class="form-control" type="number" v-model="card.max">
                </div>
              </div>
            </div>


            <div class="form-group mt-4">
              <label>
                Tier Rate
              </label>

              <div class="w-25">
                <input class="form-control" type="number" v-model="card.tier_rate">
              </div>
            </div>

            <button @click="submit(card)" class="btn btn-primary">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'loyalty_cards',

  data() {
    return {
      token: null,

      cards: [],

      silver: {
        file: null,
      },
      
      gold: {
        file: null,
      },

      platinum: {
        file: null,
      },

      black: {
        file: null,
      },
    };
  },

  methods: {
    loadToken() {
      let token = localStorage.getItem("token");

      if (token !== null) {
        token = JSON.parse(token);
        this.token = token.access_token;
      }
    },

    handleFileUpload(type) {
      this.$data[type].file = this.$refs[`${type}_file`][0].files[0];
    },

    loadCards() {
      axios
        .get(axios.lpsURL + "/cards", {
          headers: {
            Authorization: "Bearer " + this.token
          },
        })
        .then(response => {
          this.cards = response.data.data;
        });
    },

    submit(card) {
      let image_file = this.$data[card.slug].file 
        ? this.$data[card.slug].file
        : null;

      let fd = new FormData();
      fd.append("id", card.id);
      fd.append("name", card.name);
      fd.append("min", card.min);
      fd.append("max", card.max);
      fd.append("tier_rate", card.tier_rate);

      if(image_file) {
        fd.append("image", image_file);
      }

      axios.post(axios.lpsURL + "/cards/" + card.id + "/update", fd, {
          headers: {
            Authorization: "Bearer " + this.token
          }
      })
        .then(res => {
          if (!res.data.success) {
            swal({
              text: res.data.message,
              icon: "warning",
              button: "OK"
            });
          } else {
            swal({
              text: res.data.message,
              icon: "success",
              button: "OK"
            })
            .then(() => {
              window.location.reload();
            });
          }
        });
    },

    getImage(image) {
      return image + '?' + new Date().getTime();
    },
  },

  mounted() {
    this.loadToken();
    this.loadCards();
  }
}
</script>
